<script setup>
import { useAxiosDropdown } from '@/composables/useAxiosDropdown.js';

const props = defineProps({
    departamento: {
        type: Number,
        required: false,
    }
});

const { makeRequest, results, error } = useAxiosDropdown()
const baseUrl = '/api/v1/auth/dropdown/vigencia';

async function getOptions({ search }) {
    let url = new URL(baseUrl, import.meta.env.VITE_API_URL);

    if (search.trim() != "") {
        url.searchParams.append('searchtext', search);
    }

    if (props.departamento)
        url.searchParams.append('departamento', props.departamento);

    await makeRequest(url.toString());
    if (!error.value) {
        return results.value.results.map((result) => {
            return {
                label: result.option,
                value: result.id,
            }
        })
    }
    return []
}

async function reHydrate(id, cachedOption) {
    if (cachedOption) return cachedOption
    let url = new URL(baseUrl, import.meta.env.VITE_API_URL);
    url.searchParams.append('id', id);
    await makeRequest(url.toString());
    if (!error.value) {
        return {
            label: results.value.results[0].option,
            value: results.value.results[0].id,
        }
    }
    return { label: 'Error cargando' }
}
</script>

<template>
    <FormKit :option-loader="reHydrate" type="autocomplete" :options="getOptions"
        selection-removable open-on-focus :label-class="{
            'form-label': true,
            'formkit-label': false,
            'fw-bold': true,
        }" :wrapper-class="{
            'formkit-wrapper': false
        }" />
</template>